import * as Sentry from '@sentry/browser';
import { call, put, takeLatest } from 'redux-saga/effects';

import type { DeviceFragment } from '@cobliteam/api-lib/src/__generated__/graphql';
import GraphQLDeviceRequester from '@cobliteam/api-lib/src/dashboard/device/GraphQLDeviceRequester';

import type { LoadDevicesRequest } from '@cobliteam/store';
import { loadDevicesFailed, loadDevicesSucceeded } from '@cobliteam/store/src/Devices/actionCreators';
import { DevicesActionTypes } from '@cobliteam/store/src/Devices/actionTypes';

import Alert from '@cobliteam/ui/components/Alert';

const grahpQLDeviceRequester = new GraphQLDeviceRequester();

export function* requestLoadDevicesSaga(action: LoadDevicesRequest) {
  const { vehicleGroupIds } = action.payload;

  try {
    const devices: DeviceFragment[] = yield call(grahpQLDeviceRequester.getDevices, { vehicleGroupIds });

    yield put(loadDevicesSucceeded(devices));
  } catch (err) {
    Sentry.captureException(err);
    yield put(loadDevicesFailed());
    Alert.error('Houve um erro ao carregar os dispositivos, tente novamente mais tarde.');
  }
}

export function* DevicesSagasListener() {
  yield takeLatest(DevicesActionTypes.LOAD_DEVICES_REQUEST, requestLoadDevicesSaga);
}
